import { render, staticRenderFns } from "./Shortcutkeys.vue?vue&type=template&id=5f5d185f&scoped=true&"
import script from "./Shortcutkeys.vue?vue&type=script&lang=js&"
export * from "./Shortcutkeys.vue?vue&type=script&lang=js&"
import style0 from "./Shortcutkeys.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Shortcutkeys.vue?vue&type=style&index=1&id=5f5d185f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5d185f",
  null
  
)

export default component.exports